import AttachFileRoundedIcon from '@mui/icons-material/AttachFileRounded'

const AttachmentIcon = props => {
  return <AttachFileRoundedIcon width={20} height={20} {...props} />
}

export default AttachmentIcon
